import { ComponentFactoryResolver, ComponentRef, Type, ViewContainerRef } from '@angular/core';

export abstract class AbstractWrapper {
	constructor(protected componentFactoryResolver: ComponentFactoryResolver) {}

	createComponent<T>(containerRef: ViewContainerRef, type: Type<any>): ComponentRef<T> {
		const componentFactory = this.componentFactoryResolver.resolveComponentFactory(type);
		return containerRef.createComponent(componentFactory);
	}
}
